export default {"src":"/_next/static/media/bfk-logo-horiz-w.31d0f758.svg","height":350,"width":800,"blurWidth":0,"blurHeight":0};